import { Anchor, Col, Divider, Layout, Row, Space } from 'antd';
import React from 'react';

import bgImg from '@/assets/images/bg_horizontal.jpg';
import { Link } from 'react-router-dom';

const headerStyle: React.CSSProperties = {
  textAlign: 'center',
  fontSize: '2rem',
  color: '#fff',
  height: 64,
  paddingInline: 48,
  lineHeight: '64px',
  backgroundColor: '#0F7A76ee'
};

const contentStyle: React.CSSProperties = {
  textAlign: 'center',
  minHeight: 120,
  lineHeight: '120px',
  color: '#04716d',
  backgroundColor: '#0F7A7622'
};

const footerStyle: React.CSSProperties = {
  textAlign: 'center',
  color: '#fff',
  backgroundColor: '#0F7A76ee'
};

const layoutStyle: React.CSSProperties = {
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  backgroundImage: `url('${bgImg}')`,
  backgroundSize: 'cover'
};

export const Index = () => {
  return (
    <Layout style={layoutStyle}>
      <Layout.Header style={headerStyle}>EAIS 智慧屏管理系统</Layout.Header>
      <Layout.Content style={contentStyle}>
        <Divider orientation='left' className='!mt-10'>
          功能列表
        </Divider>
        <Row justify='start' className='font-bold'>
          <Col span={4}>模块</Col>
          <Col span={4}>预览地址</Col>
          <Col span={4}>下载</Col>
        </Row>
        <Row justify='start'>
          <Col span={4}>数智引导</Col>
          <Col span={4}>
            <Link to={'/szyd'} target={'_blank'}>
              预览地址
            </Link>
          </Col>
          <Col span={4}>下载</Col>
        </Row>
        <Row justify='start'>
          <Col span={4}>数智制度</Col>
          <Col span={4}>
            <Link to={'/szzd'} target={'_blank'}>
              预览地址
            </Link>
          </Col>
          <Col span={4}>下载</Col>
        </Row>
        <Row justify='start'>
          <Col span={4}>数智服务</Col>
          <Col span={4}>
            <Link to={'/szfw'} target={'_blank'}>
              预览地址
            </Link>
          </Col>
          <Col span={4}>下载</Col>
        </Row>
        <Row justify='start'>
          <Col span={4}>双碳引领</Col>
          <Col span={4}>
            <Link to={'/styl'} target={'_blank'}>
              预览地址
            </Link>
          </Col>
          <Col span={4}>下载</Col>
        </Row>
        <Row justify='start'>
          <Col span={4}>电靓乡村</Col>
          <Col span={4}>
            <Link to={'/dlxc'} target={'_blank'}>
              预览地址
            </Link>
          </Col>
          <Col span={4}>下载</Col>
        </Row>
      </Layout.Content>
      <Layout.Footer style={footerStyle}>
        技术支持: 雨乐 18660050334{' '}
        <a href='https://www.marico.cc/?f=eais' target='_blank' style={{ color: 'orange' }}>
          www.marico.cc
        </a>
      </Layout.Footer>
    </Layout>
  );
};
